import { Address, Vehicle } from '@aaa-ncnu-ie/mypolicy-api-customers';
import { PolicyTypeCd } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { capitalize, Stack, Typography, useMediaQuery } from '@mui/material';

import CircleDivider from '../../assets/icons/CircleDivider';
import theme from '../../styles/theme';
import {
  policyTypeMap,
  policyTypeMapSelector,
} from '../../utils/policyTypeUtil';
import CardAlert from '../CardAlert';
import StatusChip from '../StatusChip';

interface CardHeaderProps {
  cancelled?: boolean;
  expired?: boolean;
  policyTypeCd: PolicyTypeCd;
  headerText: string;
  vehicles?: Vehicle[];
  insuredAddress?: Address;
  claimStatus?: string;
  pastDue?: boolean;
  mortgageeBilled?: boolean;
  isNanoPolicy?: boolean;
  policyNumber: string;
  fullProductCode: string;
}

const CardHeader = ({
  policyTypeCd,
  headerText,
  cancelled,
  vehicles,
  insuredAddress,
  expired,
  claimStatus,
  pastDue,
  mortgageeBilled,
  isNanoPolicy,
  policyNumber,
  fullProductCode,
}: CardHeaderProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'));
  const iconIndex = policyTypeMapSelector(policyTypeCd, fullProductCode);
  const PolicyIcon = policyTypeMap[iconIndex].icon;

  return (
    <Stack alignItems="center" direction="row" spacing={2}>
      {!isMobile && <PolicyIcon id={policyNumber} />}
      <Stack width="100%">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center">
            {isMobile && PolicyIcon && (
              <PolicyIcon
                id={policyNumber}
                sx={{ height: 32, width: 32, mr: 1 }}
              />
            )}
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { mobile: 16, tablet: 18 },
                mr: 1,
              }}
            >
              {headerText}
            </Typography>
          </Stack>
          {cancelled && <CardAlert value="Cancelled" />}
          {expired && <CardAlert value="Expired" />}
          {claimStatus && <StatusChip label={capitalize(claimStatus)} />}
          {!cancelled && !expired && pastDue && (
            <StatusChip alert label="Past due" />
          )}
          {!cancelled && !expired && !pastDue && mortgageeBilled && (
            <StatusChip label="Paid by mortgage company" />
          )}
        </Stack>
        <Stack
          direction="row"
          divider={<CircleDivider sx={{ marginLeft: 1, marginRight: 1 }} />}
          alignItems="center"
          flexWrap="wrap"
        >
          {vehicles &&
            !isNanoPolicy &&
            vehicles?.map((vehicle, idx) => (
              <Typography
                key={idx}
                sx={{
                  fontFamily: 'Cabin',
                  fontKerning: 'normal',
                  fontSize: '14px',
                  fontWeight: 500,
                }}
              >
                {`${vehicle.year} ${vehicle.make} ${vehicle.series}`}
              </Typography>
            ))}
          {isNanoPolicy && (
            <Typography
              sx={{
                fontFamily: 'Cabin',
                fontKerning: 'normal',
                fontSize: '14px',
                fontWeight: 500,
              }}
            >
              Named Non-owner
            </Typography>
          )}
          {insuredAddress && (
            <Typography
              className="csaa-qm-encrypt"
              sx={{
                fontFamily: 'Cabin',
                fontKerning: 'normal',
                fontSize: '14px',
                fontWeight: 500,
              }}
            >
              {`${insuredAddress.addressLine1}, ${insuredAddress.city}, ${
                insuredAddress.stateProvCd
              } ${insuredAddress.postalCode.slice(0, 5)}`}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CardHeader;
